import { useI18n } from 'vue-i18n'

const ROLE_OPTIONS = [
  { label: 'Supervisor', value: 'supervisor' },
  { label: 'Administrator', value: 'admin' },
]

export const VALID_ROLES = ROLE_OPTIONS.map((r) => r.value)

export const useUserRoleOptions = () => {
  const { t } = useI18n({ useScope: 'global' })

  const localizedRoleOptions = computed(() =>
    ROLE_OPTIONS.map((r) => ({
      ...r,
      label: t(`role.${r.value}`),
    })),
  )

  return {
    options: localizedRoleOptions,
  }
}
